import React, { useContext, useMemo, useState, useEffect } from 'react';
import { Collapse, Table, Tooltip, InputNumber } from 'antd';
import { Widget, InlineEditTable, MasterDetailForm, Button, Icon, ButtonDelete, FormTextArea } from '@digital/ui';
import { usePromise, FormSubmitButton, FormatText, FormInput, FormNumber, CrudContext, Col } from '@digital/ui';

import {
  GetLinhaAtual,
  GetLinhasInjetadas,
  LinhaSla,
  ConfirmarSla,
  RefutarSlaFornecedor,
  ConfirmarSlaFornecedor,
  ConfirmarSlaGestorFornecedor,
  RefutarSlaGestorFornecedor,
  PostergarAnaliseJustificativaSla,
  ConfirmarAnaliseJustificativaSla,
  DiscordarAnaliseJustificativaSla,
  ForcarValorSla,
  ResolverPendenciaSla,
  AprovarSlaGestor,
  ReprovarSlaGestor,
} from '@app/api/sla';

import {
  GetObterMedicaoPorId,
  MedicaoEdit,
  updateDescricaoAnexoBmSla,
  GetAllAnexoMedicoesSlaPorMedicaoId,
  downloadAnexoAnaliseSla,
  DeletarAnexoMedicaoSla,
} from '@app/api/boletimMedicao';

import { hasPermission } from '@app/helpers/permissions';
import ModalComentarioSla from './ModalComentario';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getLoggedIsMRN } from '@app/helpers';
import CurrencyInput from '@app/components/CurrencyInput';
import ModalEscalarSla from './ModalEscalarSla';
import ComponeteCurso from '../../../components/componeteCurso';
import ModalJustificativaSolicitacaoConcluirSla from './ModalJustificativaSolicitacaoConcluirSla';
import ModalJustificativaAprovarSolicitacaoConcluirSla from './ModalJustificativaAprovarSolicitacaoConcluirSla';
import ModalRefutarSlaFornecedor from './ModalRefutarSlaFornecedor';
import ModalRefutarSlaGestorFornecedor from './ModalRefutarSlaGestorFornecedor';
import { useRecoilState, useRecoilValue } from 'recoil';
import { medicaoIdState, medicaoSelectedState } from '../atoms';

interface MedicaoSlaFormProps {
  onUpdate: () => any;
  onUpdatePage: () => any;
  atualizarFormularioAbas: () => any;

  atualizarFormulario: boolean;
  atualizarMedicaoSla: boolean;
  usuarioPodeEditar: boolean;

  usuarioLogadoGestorDoContratoMrn: boolean;
  usuarioLogadoFiscalDoContratoMrn: boolean;
  usuarioLogadoFiscalAlternativoDoContratoMrn: boolean;
  usuarioLogadoAdministradorAlternativoDoContratoMrn: boolean;
  usuarioLogadoAdministradorDoContratoMrn: boolean;

  usuarioLogadoFiscalDoContratoFornecedor: boolean;
  usuarioLogadoGestorDoContratoFornecedor: boolean;
  usuarioLogadoTecnicoMedicaoMrn: boolean;

  usuarioResponsavelDiretoriaProp: boolean;
  usuarioResponsavelAreaProp: boolean;
  usuarioResponsavelDepartamentoProp: boolean;
}

const AbaSla = (props: MedicaoSlaFormProps) => {
  const {
    onUpdatePage,
    usuarioLogadoGestorDoContratoMrn,
    usuarioLogadoFiscalDoContratoMrn,
    usuarioLogadoFiscalAlternativoDoContratoMrn,
    usuarioLogadoFiscalDoContratoFornecedor,
    usuarioLogadoGestorDoContratoFornecedor,
    usuarioLogadoTecnicoMedicaoMrn,
  } = props;
  const { Panel } = Collapse;
  const [medicaoSelected, setMedicaoSelected] = useRecoilState(medicaoSelectedState);

  const medicaoId = useRecoilValue(medicaoIdState);
  const [medicao, setMedicao] = useState<MedicaoEdit>();
  const [linhaSlaAtual, setLinhaSlaAtual] = useState<LinhaSla>();
  const [linhasSlaInjetadas, setLinhasSlaInjetadas] = useState<Array<LinhaSla>>();
  const [codStatusMedicao, setCodStatusMedicao] = useState(0);
  const [atualizarSla, setAtualizarSla] = useState(false);
  const [slaEditavel, setSlaEditavel] = useState(false);
  const [isMRN] = useState<boolean>(getLoggedIsMRN());

  const [bonus, setBonus] = useState();
  const [penalt, setPenalt] = useState();
  const [percentual, setPercentual] = useState();
  const [conceito, setConceito] = useState();

  useEffect(() => {
    GetObterMedicaoPorId(medicaoId).then(data => {
      setMedicao(data);
    });
  }, [medicaoId, atualizarSla]);

  useEffect(() => {
    if (medicaoId) {
      GetLinhaAtual(medicaoId).then(data => {
        if (data) {
          setConceito(data.conceito);
          setPercentual(data.percentual);
          setBonus(data.bonus);
          setPenalt(data.penalt);
          setLinhaSlaAtual(undefined);
          setLinhaSlaAtual(data);
        }
      });
    }
  }, [medicaoId, atualizarSla]);

  useEffect(() => {
    if (medicaoId) {
      GetLinhasInjetadas(medicaoId).then(data => {
        if (data) {
          setLinhasSlaInjetadas(data);
        }
      });
    }
  }, [medicaoId, atualizarSla]);

  useEffect(() => {
    if (medicao) {
      if (medicao.statusCodigo !== 0) {
        if (
          medicao.statusSlaCodigo === 1 &&
          hasPermission(['MEDICAO_SLA_EDITAR']) &&
          (usuarioLogadoGestorDoContratoMrn === true ||
            usuarioLogadoFiscalDoContratoMrn === true ||
            usuarioLogadoFiscalAlternativoDoContratoMrn === true ||
            usuarioLogadoTecnicoMedicaoMrn === true)
        ) {
          setSlaEditavel(true);
        } else {
          setSlaEditavel(false);
        }
      }
    }
  }, [medicao, atualizarSla]);

  const CarregarGrid = () => {
    setAtualizarSla(!atualizarSla);
  };

  const formatReal = (valor: string) => {
    let tmp = valor + '';
    tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
    tmp = tmp.replace('.,', ',');
    if (tmp.length > 6) {
      tmp = tmp.replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
    }
    return tmp;
  };

  const actionAnexosDaMedicao = useMemo(() => {
    const actions = [];
    if (hasPermission(['MEDICAO_SLA_CADASTRAR_ANEXO']) && isMRN) {
      actions.push(
        <ComponeteCurso
          id={medicaoSelected.id}
          nomeIdFormulario={'medicaoId'}
          enderecoApi={'medicao/updateAnexoAnaliseSla'}
          descricaoBotao={'Cadastrar anexo da Análise de SLA'}
          retorno={CarregarGrid}
          idDoComponente="anexoAnaliseDeSlaDoBm"
        />,
      );
    }
    return actions;
  }, [medicaoId]);

  const [getAllAnexoMedicoesSlaPorMedicaoId] = usePromise(
    () => (medicaoSelected ? GetAllAnexoMedicoesSlaPorMedicaoId(medicaoSelected.id) : Promise.resolve(undefined)),
    [medicaoId, atualizarSla],
    [],
  );

  const handleUpdateDescricaoGridAnexo = (values: any) => {
    let form = new FormData();
    form.append('anexoSlaId', values.id);
    form.append('Descricao', values.descricao);

    return updateDescricaoAnexoBmSla(form).then(data => {
      if (data) {
        if (data.valid === true) {
          CarregarGrid();
        }
      }
      return data;
    });
  };

  const handleDeletarAnexoMedicaoSla = (values: any) => {
    DeletarAnexoMedicaoSla(values).then(resp => {
      if (resp.valid) {
        CarregarGrid();
      }
    });
  };

  const handleUpdateGridSla = (values: any) => {
    if (linhaSlaAtual) {
      ConfirmarSla({ medicaoId: medicaoSelected.id, conceito, percentual, penalt, bonus }).then(data => {
        if (data) {
          if (data.valid === true) {
            if (data.reloadPage) {
              onUpdatePage();
            } else {
              CarregarGrid();
            }
          }
        }
      });
    }
  };

  const handleRefutarSlaFornecedor = () => {
    RefutarSlaFornecedor(medicaoId).then(data => {
      if (data) {
        CarregarGrid();
      }
    });
  };

  const handleConfirmarSlaFornecedor = () => {
    ConfirmarSlaFornecedor(medicaoId).then(data => {
      if (data) {
        CarregarGrid();
      }
    });
  };

  const handleConfirmarSlaGestorFornecedor = () => {
    ConfirmarSlaGestorFornecedor(medicaoId).then(data => {
      if (data) {
        CarregarGrid();
      }
    });
  };

  const handleRefutarSlaGestorFornecedor = () => {
    RefutarSlaGestorFornecedor(medicaoId).then(data => {
      if (data) {
        CarregarGrid();
      }
    });
  };

  const handleConfirmarAnaliseJustificativaSla = () => {
    ConfirmarAnaliseJustificativaSla(medicaoId).then(data => {
      if (data) {
        CarregarGrid();
      }
    });
  };

  const handleDiscordarAnaliseJustificativaSla = () => {
    DiscordarAnaliseJustificativaSla(medicaoId).then(data => {
      if (data) {
        CarregarGrid();
      }
    });
  };

  const handleForcarValorSla = () => {
    ForcarValorSla(medicaoId).then(data => {
      if (data) {
        onUpdatePage();
      }
    });
  };

  const handlePostergarAnaliseJustificativaSla = () => {
    PostergarAnaliseJustificativaSla(medicaoId).then(data => {
      if (data) {
        onUpdatePage();
      }
    });
  };

  const handleResolverPendenciaSla = () => {
    ResolverPendenciaSla(medicaoId).then(data => {
      if (data) {
        CarregarGrid();
      }
    });
  };

  const handleAprovarSlaGestor = () => {
    AprovarSlaGestor(medicaoId).then(data => {
      if (data) {
        onUpdatePage();
      }
    });
  };

  const handleReprovarSlaGestor = () => {
    ReprovarSlaGestor(medicaoId).then(data => {
      if (data) {
        CarregarGrid();
      }
    });
  };

  const btnAcaoGridSla = useMemo(() => {
    const actions = [];
    if (medicao) {
      if (medicao.statusSlaCodigo === 5) {
        if (usuarioLogadoGestorDoContratoMrn) {
          actions.push(<Button onClick={handleAprovarSlaGestor}>aprovar</Button>);
          actions.push(
            <Button type="danger" onClick={handleReprovarSlaGestor}>
              reprovar
            </Button>,
          );
        }
      }

      if (medicao.statusSlaCodigo === 3) {
        if (usuarioLogadoGestorDoContratoFornecedor) {
          actions.push(<Button onClick={handleConfirmarSlaGestorFornecedor}>confirmar</Button>);
          actions.push(<ModalRefutarSlaGestorFornecedor id={medicaoId} UpdateGrid={CarregarGrid} />);
        }
      }

      if (medicao.statusSlaCodigo === 2) {
        if (usuarioLogadoFiscalDoContratoFornecedor || usuarioLogadoGestorDoContratoFornecedor) {
          actions.push(
            <Button type="success" onClick={handleConfirmarSlaFornecedor}>
              confirmar
            </Button>,
          );
          actions.push(<ModalRefutarSlaFornecedor id={medicaoId} UpdateGrid={CarregarGrid} />);
        }
      }

      if (medicao.statusSlaCodigo === 1) {
        if (usuarioLogadoFiscalDoContratoMrn || usuarioLogadoGestorDoContratoMrn || usuarioLogadoFiscalAlternativoDoContratoMrn) {
          actions.push(
            <FormSubmitButton noIcon={true} confirm="Confirmar o lançamento SLA?" type="success">
              confirmar
            </FormSubmitButton>,
          );
        }
        if (usuarioLogadoFiscalDoContratoMrn && medicao.slaRefutado) {
          actions.push(<ModalEscalarSla id={medicaoId} onUpdatePage={CarregarGrid} />);
        }
      }

      if (medicao.statusSlaCodigo === 6) {
        if (usuarioLogadoGestorDoContratoMrn) {
          actions.push(<Button onClick={handleResolverPendenciaSla}> resolver pendência </Button>);
        }
      }

      if (medicao.statusSlaCodigo === 7) {
        if (usuarioLogadoGestorDoContratoMrn && !medicao.conclusaoSlaSolicitada) {
          actions.push(<ModalJustificativaSolicitacaoConcluirSla id={medicaoId} onUpdatePage={CarregarGrid} />);
        }
        if (medicao.conclusaoSlaSolicitada) {
          if (hasPermission(['MEDICAO_SLA_APROVAR_CONCLUSAO_BM_PENDENCIA_SLA'])) {
            actions.push(
              <ModalJustificativaAprovarSolicitacaoConcluirSla id={medicaoId} onUpdatePage={onUpdatePage} />,
            );
          }
        }
      }

      if (medicao.statusSlaCodigo === 4) {
        if (usuarioLogadoGestorDoContratoMrn) {
          actions.push(
            <Tooltip title="Confirma os dados de SLA digitado pela MRN e encaminha para Aceite do Fornecedor.">
              <Button onClick={handleConfirmarAnaliseJustificativaSla}>confirmar</Button>
            </Tooltip>,
          );
          actions.push(
            <Tooltip title="Discorda dos dados SLA digitados pela MRN e volta para Fiscal MRN ajustar.">
              <Button
                type="danger"
                confirm="Discorda dos dados SLA digitados pela MRN e volta para Fiscal MRN ajustar."
                onClick={handleDiscordarAnaliseJustificativaSla}>
                discordar
              </Button>
            </Tooltip>,
          );
          if (medicao.final !== true && medicao.slaPostergado !== true) {
            actions.push(
              <Tooltip title="Posterga a análise de SLA pra outro momento, neste caso o valor do SLA NÃO IMPACTA o pagamento desta medição.">
                <Button
                  type="link"
                  confirm="Posterga a análise de SLA pra outro momento, neste caso o valor do SLA NÃO IMPACTA o pagamento desta medição."
                  onClick={handlePostergarAnaliseJustificativaSla}>
                  postergar análise
                </Button>
              </Tooltip>,
            );
          }
          actions.push(
            <Tooltip title="Confirma os dados de SLA conclui o processo SLA sem necessidade de Aceite pelo Fornecedor.">
              <Button
                type="link"
                confirm="Confirma os dados de SLA conclui o processo SLA sem necessidade de Aceite pelo Fornecedor."
                onClick={handleForcarValorSla}>
                forçar valor
              </Button>
            </Tooltip>,
          );
        }
      }
    }
    return actions;
  }, [medicao, atualizarSla]);

  const columsAnexosDamedicao = [
    {
      title: 'N',
      dataIndex: 'numero',
      editable: { inputType: 'text' },
      width: '2%',
    },
    {
      title: 'Arquivo',
      dataIndex: 'nome',
      editable: { inputType: 'text' },
      width: '25%',
    },
    {
      title: 'Descrição',
      dataIndex: 'descricao',
      renderEdit: (text, record) => {
        if (codStatusMedicao != 7 && codStatusMedicao != 8) return <FormInput name="descricao" />;
        else return record.descricao;
      },
      width: '30%',
    },
    {
      title: 'Inclusão',
      dataIndex: 'dataInclusaoFormatada',
      editable: { inputType: 'text' },
      width: '10%',
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      editable: { inputType: 'text' },
      width: '20%',
    },

    {
      title: 'Opções',
      width: '10%',
      render: (text, record, index) => (
        <>
          <Tooltip title="Baixar Arquivo">
            <Button
              onClick={() => {
                downloadAnexoAnaliseSla(record.id, record.nome);
              }}
              icon="ui-download"
            />
          </Tooltip>

          {hasPermission(['MEDICAO_SLA_CADASTRAR_ANEXO']) && codStatusMedicao != 7 && codStatusMedicao != 8 ? (
            <Tooltip title="Deletar Item">
              <ButtonDelete
                type="link"
                confirm="Deseja realmente excluir este registro?"
                okText="Confirmar"
                onClick={() => handleDeletarAnexoMedicaoSla(record.id)}
                icon="science-minus"
                className="btn-delete-without-text"
              />
            </Tooltip>
          ) : (
            <> </>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['anexosDaAnaliseSla']}
        expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="anexosDaAnaliseSla" header={'Evidências da Análise de SLA'} style={{ border: 0 }}>
          <Widget actions={actionAnexosDaMedicao}>
            <PerfectScrollbar>
              <InlineEditTable
                columns={columsAnexosDamedicao}
                dataSource={getAllAnexoMedicoesSlaPorMedicaoId}
                key={'id'}
                updateItem={handleUpdateDescricaoGridAnexo}
                pagination={false}
                disablenotification={false}
              />
            </PerfectScrollbar>
          </Widget>
        </Panel>
      </Collapse>

      <Collapse bordered={false} defaultActiveKey={['gridMedicao']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel
          key="gridMedicao"
          header={'Aplicação de SLA - ' + (medicao ? medicao.statusSla : '')}
          style={{ border: 0 }}>
          {medicao ? (
            <MasterDetailForm key="formSla" onSubmit={handleUpdateGridSla}>
              <Widget actions={btnAcaoGridSla}>
                <>
                  <Col>
                    <FormInput label="Status" name="status" value={medicao.statusSla} span={3} disabled={true} />
                  </Col>
                  {linhaSlaAtual ? (
                    <>
                      <FormInput
                        label="Conceito"
                        name={'conceito'}
                        value={conceito}
                        span={3}
                        disabled={!slaEditavel}
                        onChange={e => setConceito(e.target.value)}
                      />
                      <FormInput
                        label="Percentual"
                        name={'percentual'}
                        value={percentual}
                        span={2}
                        disabled={!slaEditavel}
                        onChange={e => setPercentual(e.target.value)}
                      />
                      <CurrencyInput
                        label="Pênalti"
                        value={penalt}
                        name={'penalt'}
                        span={3}
                        disabled={!slaEditavel}
                        onChange={e => setPenalt(e)}
                      />
                      <CurrencyInput
                        label="Bônus"
                        value={bonus}
                        name={'bonus'}
                        span={3}
                        disabled={!slaEditavel}
                        onChange={e => setBonus(e)}
                      />
                      <Col span={1}>
                        <Col span={8}>
                          <FormInput
                            value={linhaSlaAtual.medicaoOriginalNumero}
                            label={'BM'}
                            name={'medicaoDisabled'}
                            span={12}
                            disabled
                          />
                        </Col>
                        <Col span={4}>
                          <br />
                          <ModalComentarioSla
                            linhaSlaId={linhaSlaAtual.id}
                            contemComentario={linhaSlaAtual.contemComentario}
                          />
                        </Col>
                      </Col>
                    </>
                  ) : (
                    <></>
                  )}
                  {medicao.justificativaEscalarSla && isMRN ? (
                    <FormTextArea
                      label="Justificativa de escalar SLA"
                      name="justificativaEscalarSla"
                      value={medicao.justificativaEscalarSla}
                      span={12}
                      rows={3}
                      disabled={true}
                    />
                  ) : null}
                </>
              </Widget>
            </MasterDetailForm>
          ) : (
            <></>
          )}
        </Panel>
      </Collapse>

      {linhasSlaInjetadas && linhasSlaInjetadas.length > 0 ? (
        <Collapse
          bordered={false}
          defaultActiveKey={['gridMedicaoInjetadas']}
          expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="gridMedicaoInjetadas" header={'Linhas SLA injetadas'} style={{ border: 0 }}>
            {medicao ? (
              <MasterDetailForm key="formSla" onSubmit={handleUpdateGridSla}>
                <Widget actions={[]}>
                  <>
                    {linhasSlaInjetadas.map(element => (
                      <div key={element.id}>
                        <FormInput
                          label="Conceito"
                          name={'conceitoDisabled'}
                          value={element.conceito}
                          span={3}
                          disabled
                        />
                        <FormInput
                          label="Percentual"
                          name={'percentualDisabled'}
                          value={element.percentual}
                          span={2}
                          disabled
                        />
                        <CurrencyInput
                          label="Pênalti"
                          value={element.penalt}
                          name={'penaltDisabled'}
                          span={3}
                          disabled
                        />
                        <CurrencyInput label="Bônus" value={element.bonus} name={'bonusDisabled'} span={3} disabled />
                        <Col span={1}>
                          <Col span={8}>
                            <FormInput
                              value={element.medicaoOriginalNumero}
                              label={'BM'}
                              name={'medicaoDisabled'}
                              span={12}
                              disabled
                            />
                          </Col>
                          <Col span={4}>
                            <br />
                            <ModalComentarioSla linhaSlaId={element.id} contemComentario={element.contemComentario} />
                          </Col>
                        </Col>
                      </div>
                    ))}
                  </>
                </Widget>
              </MasterDetailForm>
            ) : (
              <></>
            )}
          </Panel>
        </Collapse>
      ) : (
        <></>
      )}
    </>
  );
};

export default AbaSla;
